<template>
    <!-- размеры примерно 1200 х 700 -->
    <VueFlow
        :fit-view-on-init="true"
        :min-zoom="0.2"
        :max-zoom="maxZoom"
        v-model="items"
        :nodes-draggable="nodesDraggable"
        connection-line-type="Step"
        :nodes-connectable="false"
        :snap-to-grid="true"
        :snap-grid="[50, 50]"
        class="w-full h-full"
    >
        <template #node-GOOGLE_SHEET_FILE="props">
            <GoogleNode v-bind="props" :isHover="props.data.isHover" />
        </template>
        <template #node-YANDEX_CAMPAIGN="props">
            <YandexDirectNode v-bind="props" :isHover="props.data.isHover" />
        </template>
        <template #node-VKONTAKTE_CAMPAIGN="props">
            <VkCampaignNode v-bind="props" :isHover="props.data.isHover" />
        </template>
        <template #node-BITRIX_UPLOAD="props">
            <BitrixUploadNode v-bind="props" :isHover="props.data.isHover" />
        </template>
        <template #node-FILTER="props">
            <FilterNode v-bind="props" :isHover="props.data.isHover"/>
        </template>
        <template #node-MERGE="props" >
            <MergeNode v-bind="props" :isHover="props.data.isHover"/>
        </template>
        <template #edge-custom="props">
            <CustomEdge v-bind="props" :is-loading="props.data.isLoading" :isHover="props.data.isHover" />
        </template>
        <Controls 
            position="top-right"
            :showZoom="false"
            :showFitView="false"
            :showInteractive="false"
        >
            <ControlButton v-if="size === 'mini'" title="Open fullscreen" v-on:click="redirectToFullscreen">
                <BiggerArrowSvg class="w-full h-full"/>
            </ControlButton>

        </Controls>
        <Controls 
            position="bottom-right" 
            :showInteractive="false"
        />
    </VueFlow>
</template>

<script setup>
import { VueFlow } from '@vue-flow/core'
import GoogleNode from '../components/Nodes/GoogleNode.vue';
import FilterNode from '../components/Nodes/FilterNode.vue'
import MergeNode from "@/components/Nodes/MergeNode.vue";
import CustomEdge from "@/components/UI/CustomEdge.vue";
import {defineModel, defineProps, ref} from 'vue';
import { useRouter, useRoute } from 'vue-router'
import { ControlButton, Controls } from '@vue-flow/controls'
import BiggerArrowSvg from '../components/UI/BiggerArrowSvg.vue'
import YandexDirectNode from "@/components/Nodes/YandexDirectNode.vue";
import VkCampaignNode from "@/components/Nodes/VkCampaignNode.vue";
import BitrixUploadNode from "@/components/Nodes/BitrixUploadNode.vue";
//import { useVueFlow } from '@vue-flow/core';

const nodesDraggable = ref(false)

const router = useRouter()
const route = useRoute()

const items = defineModel()
const props = defineProps({
    size: {
        type: String,
        required: true
    },
    maxZoom: {
        type: String,
        required: true
    }
})

function redirectToFullscreen() {
    router.push({name: "FlowView", workflow_id: route.params.workflow_id})
}


//const { onInit, onNodeDragStop, onConnect, addEdges, setViewport, toObject } = useVueFlow()

if (props.size === "full") {
    nodesDraggable.value = true 
}
else if (props.size === "mini") {
    nodesDraggable.value = false
}

</script>

<style scoped>
    /* these are necessary styles for vue flow */
    @import '@vue-flow/core/dist/style.css';

    /* this contains the default theme, these are optional styles */
    @import '@vue-flow/core/dist/theme-default.css';
</style>
